import React, { Component } from 'react';

class ModalCambiarEstado extends Component {

    constructor(props) {
        super(props);
    }

    mostrarModalCambiarEstado(mostrarModal, totalMovimientos) {
        this.props.mostrarModalCambiarEstado(mostrarModal, totalMovimientos);
    }

    render() {
        const { ajusteCargo, checkConfirmarArray, checkDenegarRestablecerArray, objFiltradoBtnVer, totalChecks, currentScope } = this.props;

        let ajusteCargoEstado = objFiltradoBtnVer && objFiltradoBtnVer.estado ? objFiltradoBtnVer.estado : "PEND. CONFIRMACIÓN";
        let tituloDenegarRestablecer = ""

        switch (ajusteCargoEstado) {
            case "PEND. CONFIRMACIÓN":
                tituloDenegarRestablecer = "Denegar";
                break;
            case "DENEGADO":
                tituloDenegarRestablecer = "Restablecer";
                break;
        }

        let movimientosConfirmados = 
        ajusteCargo.map(ajusteCargo => {
            return checkConfirmarArray.includes(ajusteCargo.Id) ? ajusteCargo : undefined
        });

        //Elimino los elementos vacíos
        movimientosConfirmados = movimientosConfirmados.filter(movimientoConfirmado => movimientoConfirmado)
        //Creo array de movimientos confirmados de débito
        let movimientosConfirmadosDebito = movimientosConfirmados.filter(movimientoConfirmado => movimientoConfirmado.DebitoCredito == "D")
        //Creo array de movimientos confirmados de crédito
        let movimientosConfirmadosCredito = movimientosConfirmados.filter(movimientoConfirmado => movimientoConfirmado.DebitoCredito == "C")
        

        let movimientosDenegados = 
        ajusteCargo.map(ajusteCargo => {
            return checkDenegarRestablecerArray.includes(ajusteCargo.Id) ? ajusteCargo : undefined
        });

        //Elimino los elementos vacíos
        movimientosDenegados = movimientosDenegados.filter(movimientoDenegado => movimientoDenegado)
        //Creo array de movimientos denegados/reestablecidos de débito
        let movimientosDenegadosDebito = movimientosDenegados.filter(movimientoDenegado => movimientoDenegado.DebitoCredito == "D")
        //Creo array de movimientos denegados/reestablecidos de débito
        let movimientosDenegadosCredito = movimientosDenegados.filter(movimientoDenegado => movimientoDenegado.DebitoCredito == "C")

        return (
            <div className='modalContainer'>
                <div className="modal-cambiar-estados">
                    <div className="modal-content">
                        <div className="modal-header-cambiar-estados">
                            <h2 className="modal-title">Cambiar Estado</h2>
                        </div>
                        <div className="modal-body-cambiar-estados">
                            <div className="modal-body-container-cambiar-estados">
                                {movimientosConfirmados.length > 0 ?
                                    <div>
                                        <h3 style={{ margin: '0px 0px 20px 0px' }}>Confirmar</h3>
                                        {movimientosConfirmadosDebito.length > 0 ?
                                        <div>
                                            <div className="modal-cambiar-estados-font-debito">Débito:</div>
                                            <div className="modal-cambiar-estados-font">Improte total: ${movimientosConfirmadosDebito.reduce(function (valorInicial,valorActual) {return valorInicial + valorActual.ImporteSinIva}, 0)}</div>
                                            <div className="modal-cambiar-estados-font">Cantidad de registros: {movimientosConfirmadosDebito.length}</div>
                                        </div>
                                        :
                                        null}

                                        {movimientosConfirmadosCredito.length > 0 ?
                                        <div>
                                            <div className="modal-cambiar-estados-font-credito">Crédito:</div>
                                            <div className="modal-cambiar-estados-font">Improte total: ${movimientosConfirmadosCredito.reduce(function (valorInicial,valorActual) {return valorInicial + valorActual.ImporteSinIva}, 0)}</div>
                                            <div className="modal-cambiar-estados-font">Cantidad de registros: {movimientosConfirmadosCredito.length}</div>
                                        </div>
                                        :
                                        null}
                                    </div>
                                    :
                                    null
                                }
                                {movimientosConfirmados.length > 0 && movimientosDenegados.length > 0 ?
                                    <div className="modal-cambiar-estados-separador"></div>
                                    :
                                    null
                                }
                                {movimientosDenegados.length > 0 ?
                                    <div>
                                        <h3 style={{ margin: '0px 0px 20px 0px' }}>{tituloDenegarRestablecer}</h3>
                                        {movimientosDenegadosDebito.length > 0 ?
                                        <div>
                                        <div className="modal-cambiar-estados-font-debito">Débito:</div>
                                        <div className="modal-cambiar-estados-font">Improte total: ${movimientosDenegadosDebito.reduce(function (valorInicial,valorActual) {return valorInicial + valorActual.ImporteSinIva}, 0)}</div>
                                        <div className="modal-cambiar-estados-font">Cantidad de registros: {movimientosDenegadosDebito.length}</div>
                                        </div>
                                        :
                                        null}

                                        {movimientosDenegadosCredito.length > 0 ?
                                        <div>
                                            <div className="modal-cambiar-estados-font-credito">Crédito:</div>
                                            <div className="modal-cambiar-estados-font">Improte total: ${movimientosDenegadosCredito.reduce(function (valorInicial,valorActual) {return valorInicial + valorActual.ImporteSinIva}, 0)}</div>
                                            <div className="modal-cambiar-estados-font">Cantidad de registros: {movimientosDenegadosCredito.length}</div>
                                        </div>
                                        :
                                        null}
                                    </div>
                                    :
                                    null
                                }
                            </div>
                        </div>
                        <div className="modal-footer-modal-cambiar-estados">
                            <button onClick={() => this.mostrarModalCambiarEstado(false, totalChecks)} className="btn btn-secondary">Cancelar</button>
                            <button className="left-separator-xs btn btn-cta" onClick={() => this.mostrarModalCambiarEstado(false, totalChecks)}>Aceptar</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ModalCambiarEstado;